@if (eventListConfig) {
<div class="event-list">
  <qa-grid-data [config]="eventListConfig">
    <qa-no-entity-info noContent [listInfo]="listInfo"></qa-no-entity-info>
  </qa-grid-data>
</div>
}
